<template>
  <bg-style v-if="enabled" v-imloading="loading" :is-disabled="$store.getters.isStandAloneMode" :bg="model.background" :mobile-bg="model.mobileBackground"
    :class="{ 'mobile': isMobile }" class="sign-activity-row" :style="getStyle">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <div v-if="model.titleVisible" class="sign-activity-row__title">
        <rich-text v-model="model.title" :editing="editing" :stroke.sync="model.titleStroke" class="w-full title"
          :disabled="!editing" theme="snow" />
      </div>
      <div v-if="model.subtitleVisible" class="sign-activity-row__subtitle mt-4">
        <rich-text v-model="model.subtitle" :editing="editing" :stroke.sync="model.subTitleStroke" :disabled="!editing"
          theme="snow" />
      </div>
      <div class="sign-activity-row__info flex justify-center text-16 gap-20 pt-10">
        <span>{{ $t('siteBuild.signWidget.tip1') }} {{ signData.has_sign_in_days }}</span>
        <span v-if="activityData?.activity_rule?.allow_remediation">{{ $t('siteBuild.signWidget.tip2') }} {{
          signData.remain_appending_days }}</span>
      </div>
      <div ref="content" class="sign-activity-row__list pt-6">
        <bg-style v-for="(item, index) in signData.sign_in_list" :key="index" :ref="`item-${index}`"
          :radius="model.radius" class="item" :bg="model.signBackground" @click.native="handleShowDetail(item)">
          <img v-if="((editing && index === 0) || item.is_sign_in) && model.signedMark?.backgroundImage"
            class="signed-icon" :src="model.signedMark.backgroundImage" alt="signed" />
          <bg-style class="thumb" :bg="model.logoBackground" :radius="[model.radius, model.radius, 0, 0]">
            <div class="day">{{ $t('siteBuild.signWidget.day', { day: item.day_no }) }}</div>
            <div class="logo-box">
              <img class="relative" :src="model.detailVisible ? (item.cover || item.thumb) : item.thumb" alt="icon" />
            </div>
            <div v-if="!model.detailVisible && (item?.gift_list && item?.gift_list?.[0])" class="count">x{{ item?.gift_list?.[0]?.num || 0 }}</div>
          </bg-style>
          <div class="info">
            <div v-if="model.detailVisible" class="details gap-4">
              <div v-for="(gift, gIndex) in item.gift_list" :key="gIndex" class="pack flex items-center flex-shrink-0">
                <img class="icon" :src="gift.gift_goods_logo" alt="" />
                <i class="el-icon-close font-bold" />
                <span class="number">{{ gift.num }}</span>
              </div>
            </div>
            <bg-style v-if="(editing && index === 0) || item.is_sign_in" class="handle" :bg="model.doneBackground"
              :radius="model.radius">
              <span class="relative">{{ $t('siteBuild.signWidget.signed') }}</span>
            </bg-style>
            <bg-style v-else-if="(editing && index === 1) || item.is_appending" class="handle" :radius="model.radius"
              :bg="model.repairBackground" @click.native.stop="handleSignIn(item)">
              <span class="relative">{{ $t('siteBuild.signWidget.repair') }}</span>
            </bg-style>
            <bg-style v-else-if="(editing && index === 2) || item.is_available_sign_in" class="handle"
              :radius="model.radius" :bg="model.buttonBackground" @click.native.stop="handleSignIn(item)">
              <span class="relative">{{ $t('siteBuild.signWidget.sign') }}</span>
            </bg-style>
            <bg-style v-else-if="item.is_expired" class="handle" :radius="model.radius" :bg="model.doneBackground">
              <span class="relative">{{ $t('siteBuild.expired') }}</span>
            </bg-style>
            <bg-style v-else class="handle unsign" :radius="model.radius" :bg="model.doneBackground">
              <span class="relative">
                {{ $t('siteBuild.signWidget.sign') }}
              </span>
              <img v-if="model.unSignMark.backgroundImageShow" :src="model.unSignMark.backgroundImage" alt></img>
            </bg-style>
          </div>
        </bg-style>
      </div>
      <template v-if="signData.consecutive_list.length">
        <div class="consecutive-title mt-[20px]">
          <rich-text v-model="model.secondTitle" :editing="editing" class="relative" />
          <rich-text v-model="model.secondSubtitle" :editing="editing" class="mt-4 relative" />
        </div>
        <div class="sign-activity-row__list pt-6"
          :class="{ 'justify-center': signData.consecutive_list.length <= 5 && !isMobile }">
          <bg-style v-for="(item, index) in signData.consecutive_list" :key="index" :radius="model.radius"
            :bg="model.signBackground" class="item" @click.native="handleShowDetail(item)">
            <bg-style class="thumb" :bg="model.logoBackground" :radius="[model.radius, model.radius, 0, 0]">
              <div class="day">{{ $t('siteBuild.signWidget.day', { day: item.sign_in_consecutive_days }) }}</div>
              <div class="logo-box">
                <img class="relative" :src="model.detailVisible ? (item.cover || item.thumb) : item.thumb" alt="icon" />
              </div>
              <div v-if="!model.detailVisible && item.gift_list && item.gift_list[0]" class="count">x{{
                item.gift_list[0].num }}</div>
            </bg-style>
            <div class="info">
              <div v-if="model.detailVisible" class="details gap-4">
                <div v-for="(gift, gIndex) in item.gift_list" :key="gIndex"
                  class="pack flex items-center flex-shrink-0 font-bold">
                  <img class="icon" :src="gift.gift_goods_logo" alt="" />
                  <i class="el-icon-close font-bold" />
                  <span class="number">{{ gift.num }}</span>
                </div>
              </div>
              <bg-style v-if="(editing && index === 0) || item.is_sign_in" class="handle" :radius="model.radius"
                :bg="model.doneBackground">
                <span class="relative">{{ $t('siteBuild.activity.haveGet') }}</span>
              </bg-style>
              <bg-style v-else-if="(editing && index === 1) || item.is_get" class="handle" :radius="model.radius"
                :bg="model.buttonBackground" @click.native.stop="handleGetGift(item)">
                <span class="relative">{{ $t('siteBuild.activity.get') }}</span>
              </bg-style>
              <bg-style v-else class="handle" :radius="model.radius" :bg="model.doneBackground">
                <span class="relative">{{ $t('siteBuild.activity.get') }}</span>
              </bg-style>
            </div>
          </bg-style>
        </div>
      </template>
    </module-block>
    <sign-info ref="info" :data="currentRow" :custom-style="getStyle" :is-mobile="isMobile" />
  </bg-style>
</template>

<script>
import { Empty } from 'element-ui'
import SignInfo from './info.vue'
import RichText from '~/components/richText/index.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'
import logicMixin from './logicMixin'

export default {
  name: 'RowContent',
  components: {
    ModuleBlock,
    RichText,
    SignInfo,
    [Empty.name]: Empty
  },
  mixins: [logicMixin]
}
</script>

<style lang="less">
.sign-activity-row {
  padding: 20px 0;

  &__title,
  &__subtitle {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
  }

  &__info {
    position: relative;
    color: var(--sign-text-color);
  }

  &__list {
    display: flex;
    max-width: 1210px;
    margin: 0 auto;
    position: relative;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 10px;

    .item {
      width: 160px;
      flex-shrink: 0;
      box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.08);
      cursor: pointer;

      .signed-icon {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 200;
        border-radius: var(--sign-radius);
      }

      &:first-of-type {
        margin-left: 8px;
      }

      &:last-of-type {
        margin-right: 10px;
      }

      .thumb {
        width: 100%;
        height: 140px;
        position: relative;

        .day {
          width: 100%;
          text-align: center;
          font-size: 15px;
          position: relative;
          line-height: 33px;
          background: var(--sign-day-background);
          color: var(--sign-day-color);
          border-radius: var(--sign-radius) var(--sign-radius) 0 0;
        }

        .logo-box {
          height: calc(140px - 36px);
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          img {
            max-width: 72px;
            max-height: 72px;
          }
        }

        .count {
          position: absolute;
          right: 10px;
          bottom: 6px;
          min-height: 18px;
          line-height: 18px;
          color: var(--sign-text-color);
          font-size: 16px;
          font-weight: bold;
        }
      }

      .info {
        padding: 10px;
        position: relative;

        .details {
          display: flex;
          margin: 0 auto;
          overflow: auto;
          max-width: 100%;
          white-space: nowrap;
          color: var(--text-color);
          flex-wrap: nowrap;
          height: 40px;
          padding-bottom: 10px;

          &::-webkit-scrollbar {
            height: 0;
          }

          .pack {
            font-size: 14px;
            font-weight: bold;

            &:first-of-type {
              margin: 0 auto;
            }

            .icon {
              width: 30px;
              height: 30px;
            }
          }
        }

        .name {
          text-align: center;
          padding-top: 12px;
          font-size: 16px;
          color: var(--sign-text-color);
        }

        .el-icon-close {
          color: var(--sign-text-color-50);
          font-size: 12px;
        }

        .number {
          color: var(--sign-text-color-50);
          font-size: 12px;
        }

        .handle {
          text-align: center;
          line-height: 40px;
          cursor: pointer;
          font-size: 16px;
          color: var(--sign-button-color);
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            max-width: 80px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          &.unsign {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              max-width: 24px;
              position: relative;
            }
          }
        }
      }
    }
  }

  &.mobile {
    padding: 10px;

    .sign-activity-row__title,
    .sign-activity-row__subtitle {
      padding: 0 11px;
    }

    .consecutive-title {
      padding: 0 11px;
    }

    .sign-activity-row__list {
      gap: 8px;
      padding-left: 4px;

      .item {
        width: 100px;

        &:first-of-type {
          margin-left: 0;
        }

        .details {
          font-size: 12px;
          height: 30px;

          .icon {
            width: 20px;
            height: 20px;
          }

          .number {
            font-size: 12px;
          }
        }

        .thumb {
          height: 84px;

          .count {
            font-size: 12px;
          }

          .day {
            font-size: 12px;
            line-height: 24px;
          }

          .logo-box {
            height: calc(84px - 24px);

            img {
              max-width: 50px;
              max-height: 50px;
            }
          }
        }

        .info {
          padding: 5px;

          .handle {
            line-height: 24px;
            height: 24px;
            padding: 0 10px;

            span {
              font-size: 12px;
            }

            &.unsign {
              img {
                max-width: 16px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
